export enum TenantType {
  FOOD = 'FOOD',
  SERVICE = 'SERVICE',
}
